var map = {
	"./config": 116,
	"./config.js": 116,
	"./index": 214,
	"./index.js": 214,
	"./option-manager": 117,
	"./option-manager.js": 117,
	"./parsers": 215,
	"./parsers.js": 215,
	"./removed": 216,
	"./removed.js": 216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/lib/transformation/file/options ^\.\/.*$
 ** module id = 336
 ** module chunks = 0
 **/